module.exports = __webpack_public_path__ + "img/purchase-icon-active.fb964b13.svg";